import React from 'react';
import type { TablemaintRow } from '../../services/tablemaint.service';
import PrintTestPageButton from '../printing/PrintTestPageButton';

/**
 * Row-level actions a registry entry can ask the generic drawer to render beside
 * "View Edit History", by key (`DataTableDef.drawerActions`). Kept here, not in the
 * registry, so the config file never imports React components.
 */
export const DRAWER_ACTIONS: Record<string, (row: TablemaintRow) => React.ReactNode> = {
  'print-test-page': (row) => (
    <PrintTestPageButton printer={String(row.installname ?? '')} type={row.type == null ? null : String(row.type)} />
  ),
};
